import React, { useRef } from 'react'
import { useEffect, useState } from 'react';
import userService from '@/services/setting/userService';
import tagsService from '@/services/setting/tagsService';
import { useAbility } from '@/providers/';
import { KeenIcon } from '@/components';
import { useNavigate } from 'react-router-dom';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import 'datatables.net-select-dt';
import 'datatables.net-responsive-dt';
import { createRoot } from 'react-dom/client';
import { SelectInput, DateInput, MATTER_STATUS_OPTIONS, FilterContainer } from '@/components/TableFilter'
import { cn } from '@/lib/utils';
import { renderMultiAvatars, FiltersToFormData, getAccessToken, decodeHtmlEntities, createDataTableOptions, createDataTableConfig } from '@/utils'
import { useAuthContext } from '@/auth';
import { goTo403 } from "@/utils/Navigation";
import * as Yup from 'yup';
import { Exporter } from '../../exporter';
import { useContactOptions } from '@/hooks';
import { ColumnToggleDropdown } from '../../TableFilter/ColumnToggleDropdown';
import { useUserOptions } from '@/hooks'

DataTable.use(DT);
const Matters = ({ dataFromParent, onNavigateFromChild, onClearChildProps }) => {
    console.log('dataFromParent', dataFromParent)
    const { logout } = useAuthContext();
    const Navigate = useNavigate()
    const loadContactOptions = useContactOptions({ defaultPageSize: 20 });
    const [showFilter, setShowFilter] = useState(false)
    const [filterData, setFilterData] = useState({
        assigned_to: null,
        status: null,
        created_at: null,
        tags: null,
        from_date: null,
        to_date: null,
        date_range: null,
        created_by: null,
        contact_id: dataFromParent?.contactId,
    });
    const tableRef = useRef(null);
    const API_URL = import.meta.env.VITE_APP_BASE_URL;
    const token = getAccessToken();
    const filterRef = useRef(filterData);
    const loadUserOptions = useUserOptions({ defaultPageSize: 20 });

    useEffect(() => {
        filterRef.current = filterData;
    }, [filterData]);

    const badgeClass = {
        open: 'badge-success',
        pending: 'badge-info',
        archived: 'badge-warning',
        closed: 'badge-danger',
    }

    const columns = [
        // {
        //     title: 'S#',
        //     name: 'serial',
        //     data: null,
        //  orderable: true,se,
        //     render: (data, type, row, meta) => meta.row + 1,
        // },
        {
            title: 'Name',
            data: 'name',
            name: 'name',
            render: function (data, type, row) {
                return `<div id="matter-cell-${row.id}"></div>`;
            }
        },
        {
            data: 'contact.fullName',
            title: 'Contact',
            name: 'contact',
            orderable: false,
            render: function (data, type, row) {
                return `<div id="contact-cell-${row.id}"></div>`;
            }
        },
        {
            data: 'status',
            title: 'Status',
            name: 'status',
            orderable: true,
            render: function (value) {
                return `<span class="badge badge-pill badge-outline capitalize ${badgeClass[value]} gap-1 items-center">
            <span class="badge badge-dot size-1.5 ${badgeClass[value]}"></span>
            ${value}
          </span>`
            }
        },
        {
            title: 'Invoices',
            data: 'invoices',
            name: 'invoices',
            orderable: false,
            render: function (data, type, row) {
                return `<div id="invoice-cell-${row.id}"></div>`;
                // return `<span>${row.first_name} ${row.last_name}</span>`;
            }
        },
        {
            title: 'Invoices Total',
            data: 'invoices_total',
            name: 'invoices_total',
            orderable: false,
            // render: function (data, type, row) {
            //     return `$${row.invoices_total}`
            // }
            render: function (data, type, row) {
                return `<div id="invoice-total-cell-${row.id}"></div>`;
            }
        },
        { data: 'created_at', title: 'Created At', name: 'created_at', orderable: false },
        {
            title: 'Assigned To',
            name: 'assigned_to',
            data: 'assigned_to',
            orderable: true,
            searchable: false,
            render: function (data, type, row) {
                return `<div id="assigned-to-${row.id}"></div>`;
            }
        },
        {
            title: '',
            data: null,
            orderable: false,
            searchable: false,
            render: function (data, type, row) {
                return `<div id="action-cell-${row.id}"></div>`;
            }
        }
    ];

    const defaultVisibleColumns = ['name', 'contact', 'status', 'invoices', 'invoices_total', 'created_at'];

    const ajaxConfig = createDataTableConfig(`/matters/data_table_list?${dataFromParent?.contactId ? '' : 'has[invoices]=1'}`, filterRef, token, logout);

    const options = createDataTableOptions({
        order: [[5, 'desc']],
        initComplete: function () {
            const api = this.api();
            api.columns().every(function () {
                const col = this;
                const name = col.settings()[0].aoColumns[col.index()].name;
                if (name && !defaultVisibleColumns.includes(name)) {
                    col.visible(false);
                }
            });
        },
        drawCallback: function () {
            const api = this.api();
            const rows = api.rows({ page: 'current' }).data();

            rows.each((row) => {
                const container = document.getElementById(`assigned-to-${row.id}`);
                if (container) {
                    if (!container._reactRoot) {
                        container._reactRoot = createRoot(container);
                    }
                    container._reactRoot.render(renderMultiAvatars(row.assigned_to));
                }
                const matterContainer = document.getElementById(`matter-cell-${row.id}`);
                if (matterContainer) {
                    if (!matterContainer._reactRoot) {
                        matterContainer._reactRoot = createRoot(matterContainer);
                    }
                    matterContainer._reactRoot.render(renderMatterName(row));
                }

                const invoiceContainer = document.getElementById(`invoice-cell-${row.id}`);
                if (invoiceContainer) {
                    if (!invoiceContainer._reactRoot) {
                        invoiceContainer._reactRoot = createRoot(invoiceContainer);
                    }
                    invoiceContainer._reactRoot.render(renderInvoiceNumber(row));
                }

                const invoiceTotalContainer = document.getElementById(`invoice-total-cell-${row.id}`);
                if (invoiceTotalContainer) {
                    if (!invoiceTotalContainer._reactRoot) {
                        invoiceTotalContainer._reactRoot = createRoot(invoiceTotalContainer);
                    }
                    invoiceTotalContainer._reactRoot.render(renderInvoiceTotal(row));
                }

                const contactContainer = document.getElementById(`contact-cell-${row.id}`);
                if (contactContainer) {
                    if (!contactContainer._reactRoot) {
                        contactContainer._reactRoot = createRoot(contactContainer);
                    }
                    contactContainer._reactRoot.render(renderContactName(row));
                }
            });
        },
    });

    const resetFilters = () => {
        const cleared = {
            assigned_to: null,
            status: null,
            created_at: null,
            tags: null,
            from_date: null,
            to_date: null,
            date_range: null,
            created_by: null,
            contact_id: null,
        };

        setFilterData(cleared);
        filterRef.current = cleared;
        refresh()
        onClearChildProps?.();
    };

    const handleFilterChange = (key, val) => {
        setFilterData((prev) => {
            const updated = { ...prev, [key]: val };
            filterRef.current = updated;
            console.log('updated', updated)
            return updated;
        });
    };

    const handleToggleFilter = () => {
        setShowFilter(prev => !prev)
    }

    const fetchLookup = async (type) => {
        switch (type) {
            case 'users':
                const { data } = await userService.getAllUsers();
                return data.map((user) => ({ label: user.first_name + ' ' + user.last_name, value: user.id, email: user.email }));
            case 'tags':
                const tags = await tagsService.getAllTags();
                // console.log(tags)
                return tags.data.filter(f => f.type === 'matter').map((tag) => ({ label: tag.name, value: tag.name }));
            default:
                return [];
        }
    };

    const refresh = () => {
        const table = tableRef.current.dt();
        table.ajax.reload();
    };

    const handleNavigateMatter = (id) => {
        Navigate(`/matters/detail/${id}`)
        // Navigate(`/matters/detail/${id}?tab=About`)
    }

    const renderMatterName = (row) => {
        const { id, name } = row;
        const fullName = decodeHtmlEntities(name || ""); // ensure safe decode

        return (
            <span
                onClick={() => handleNavigateMatter(id || '')}
                className="cursor-pointer link"
            >
                {fullName}
            </span>
        );
    }

    const renderInvoiceNumber = (row) => {
        console.log('rowASdASD', row)
        const { invoices } = row
        if (!Array.isArray(invoices) || invoices.length === 0) return <span>-</span>;

        return (
            <div className="flex flex-wrap gap-2">
                <span className="cursor-pointer link"
                    onClick={() => {
                        onNavigateFromChild?.(
                            "Invoices",
                            {
                                matterId: row.id,
                                matterName: row.name
                            }
                        );
                    }}
                >
                    {invoices.length} {invoices.length === 1 ? 'Invoice' : 'Invoices'}
                </span>
            </div>
        );
    }

    const renderInvoiceTotal = (row) => {
        const { invoices } = row;
        if (!Array.isArray(invoices) || invoices.length === 0) return <span>-</span>;

        // Convert all totals to numbers and sum them
        const mergedTotal = invoices.reduce((sum, group) => {
            const val = Math.round(Number(group.total) * 100); // convert to cents
            return sum + val;
        }, 0);
        console.log('---><=', mergedTotal, invoices)
        return <span>${(mergedTotal / 100).toFixed(2)}</span>;
    };

    const renderContactName = (row) => {
        if (!row.contact) {
            return <span>-</span>;
        }
        const fullName = row.contact.first_name + ' ' + row.contact.last_name;
        const { id } = row.contact;
        return (
            <span onClick={() => { handleNavigateConatct(id) }} className='cursor-pointer link'>{fullName}</span>
        )
    }

    const handleNavigateConatct = (id) => {
        Navigate(`/contacts/${id}/`)
    }


    return (
        <>
            {/* Filters */}
            <FilterContainer
                show={showFilter}
                onApply={() => refresh()}
                onReset={resetFilters}
            >
                {/* <SelectInput
                    label="Created By"
                    type="users"
                    value={filterData.created_by}
                    onChange={(val) => handleFilterChange('created_by', val)}
                    fetchLookup={fetchLookup}
                    customClass="sm:w-[32%] w-full"
                /> */}

                <SelectInput
                    isMulti={true}
                    label="Assigned To"
                    type="users"
                    value={filterData.assigned_to}
                    onChange={(val) => handleFilterChange('assigned_to', val)}
                    loadOptions={loadUserOptions}
                    pageSize={20}
                    customClass="sm:w-[32%] w-full"
                />

                <SelectInput
                    label="Contact"
                    type="contact"
                    value={filterData.contact_id}
                    onChange={(val) => handleFilterChange('contact_id', val)}
                    loadOptions={loadContactOptions}
                    pageSize={20}
                    customClass="sm:w-[32%] w-full"
                />

                <SelectInput
                    label="Status"
                    value={filterData.status}
                    onChange={(val) => handleFilterChange('status', val)}
                    staticOptions={MATTER_STATUS_OPTIONS}
                    customClass="sm:w-[32%] w-full"
                />

                {/* <SelectInput
                    label="Tags"
                    type="tags"
                    isMulti={true}
                    value={filterData.tags}
                    onChange={(val) => handleFilterChange('tags', val)}
                    fetchLookup={fetchLookup}
                    customClass="sm:w-[32%] w-full"
                /> */}

                <DateInput
                    customClass="sm:w-[32%] w-full"
                    label="Created At - (From, To)"
                    mode="range"
                    value={filterData.date_range}
                    onChange={(range) => {
                        setFilterData(prev => ({
                            ...prev,
                            from_date: range?.from ?? null,
                            to_date: range?.to ?? null,
                            date_range: range,
                        }));
                    }}
                />
            </FilterContainer>

            <div className="min-w-full mb-4 card">
                <div className="card-header !block">
                    <div className='flex flex-wrap items-center justify-between'>
                        <div className='flex items-center gap-1'>
                            <ColumnToggleDropdown tableRef={tableRef} columns={columns} defaultVisibleColumns={defaultVisibleColumns} />
                            <h3 className="card-title">{dataFromParent?.contactName ? `${dataFromParent?.contactName} Matters` : 'All Matters'}</h3>
                        </div>

                        <div className='flex flex-wrap items-center gap-2'>
                            <button className='text-xs btn btn-sm btn-primary btn-outline' onClick={handleToggleFilter}>
                                <KeenIcon icon="filter" className="w-fit btn-icon" />
                                {showFilter ? 'Hide Advanced Filters' : 'Advanced Filters'}
                            </button>
                            <div>
                                <Exporter
                                    tableRef={tableRef}
                                    module="matter"
                                    // columns={[]}
                                    columns={columns}
                                    filters={filterData}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <DataTable
                    id="matter-table"
                    ajax={ajaxConfig}
                    columns={columns}
                    options={options}
                    ref={tableRef}
                />
            </div>
        </>
    );
};

export { Matters }
